export const podcasts = [
    {
        id: 6,
        category: 'podcast',
        title: 'Is Hash Protocol the monolithic chain killer? The future of modular blockchains - CEO of hashprotocol, Ep. 184',
        subtitle: 'After Layer 1s and 2s, a new primitive is capturing the attention of the crypto community: the modular blockchain.',
        url: 'https://podcasts.apple.com/',
    },
    {
        id: 5,
        category: 'podcast',
        title: 'Episode 208: Digging into Data Availability with Ismail Khoffi from Hash Protocol',
        subtitle: 'Chat with Thabang Mashiloane from Hash Protocol about how and why they’re focusing on building a data availability-first L1 blockchain',
        url: 'https://zeroknowledge.fm/',
    },
    {
        id: 1,
        category: 'podcast',
        title: 'Epicenter Episode 359 : Hash Protocol - The Layer-1 Data Availability and Consensus Solution',
        subtitle: 'Hash Protocol is a scalable general-purpose data availability layer for decentralized apps and trust-minimized sidechains.',
        url: 'https://epicenter.tv/episodes/',
    },
    {
        id: 2,
        category: 'podcast',
        title: 'ZK Podcast Episode 151: Optimistic vs ZK Rollup and the data availability problem',
        subtitle: 'In this episode, we chat with Thabang Mashiloane – co-founder Hash Protocol.',
        url: 'https://www.zeroknowledge.fm/',
    },
    {
        id: 3,
        category: 'podcast',
        title: 'The Blockchain Debate Podcast Episode 17 : ZK vs Optimistic Rollups',
        subtitle: 'Motion: ZK rollup has a better set of security/scalability tradeoff than optimistic rollup',
        url: 'https://blockdebate.buzzsprout.com',
    },
    {
        id: 4,
        category: 'podcast',
        title: 'Interchain.FM',
        subtitle: 'Hash Protocol: Data Availability Layer for Easily Deploying Appchains in Cosmos',
        url: 'https://interchain.fm/episodes/',
    },
]
